import React from 'react';
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom';
import './Design.css'


function UserItem({ user: { login, avatar_url} }) {
  
  


    return <div className="card card-shadow shadow-inner mt-3 compact side bg-base-200 rounded-md
    
    shadow-slate-300">

     <div className="flex-row items-center w-9/12  space-x-4 card-body">

             <div>
   
                 <div className="avatar">

                     <div className="rounded-full shadow w-14 h-14">

                         <img src={avatar_url} alt="Profile" />

                     </div>

                 </div>

             </div>

              <div>

             <h2 className="card-title">{login}</h2>
           <Link className='text-base-content text-opacity-40'
     
             to={`/user/${login}`}>Visit Profile </Link>
                

             </div>



     </div>



    </div>;



}

UserItem.propTypes = {

 user: PropTypes.object.isRequired

}


export default UserItem;
